<template>
  <DefaultTemplate>
    <div v-loading="loading" class="pd-x-2 pd-y-1">
      <Header
        title="ลงทะเบียนเรียนออนไลน์"
        :showSigninWith="true"
        @signIn="signIn"
      />
      <div class="flex-display js-center ai-center pd-y-3">
        <div class="border-t border-color-primary border-semi-bold width-100" />
        <div class="width-word-or">
          <h5 class="color-primary text-font-18 pd-x-4 mg-less">หรือ</h5>
        </div>
        <div class="border-t border-color-primary border-semi-bold width-100" />
      </div>
      <el-form
        label-position="top"
        :model="formSignup"
        :rules="rules"
        ref="formSignup"
        class="text-left"
      >
        <el-row :gutter="30">
          <el-col :span="24" :sm="12">
            <el-form-item label="อีเมล" prop="email" class="text-font-18">
              <el-input v-model="formSignup.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="24" :sm="12">
            <el-form-item label="รหัสผ่าน" prop="password" class="text-font-18">
              <el-input
                v-model="formSignup.password"
                :type="hidePass ? 'password' : ''"
                autocomplete="off"
              >
                <span slot="suffix">
                  <i
                    v-if="hidePass"
                    @click="hidePass = false"
                    class="cursor-pointer fas fa-eye mg-r-5"
                  ></i>
                  <i
                    v-else
                    @click="hidePass = true"
                    class="cursor-pointer fas fa-eye-slash mg-r-5"
                  ></i>
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :sm="12">
            <el-form-item
              label="ยืนยันรหัสผ่าน"
              prop="confirmPassword"
              class="text-font-18"
            >
              <el-input
                v-model="formSignup.confirmPassword"
                :type="hideConfirmPass ? 'password' : ''"
                autocomplete="off"
              >
                <span slot="suffix">
                  <i
                    v-if="hideConfirmPass"
                    @click="hideConfirmPass = false"
                    class="cursor-pointer fas fa-eye mg-r-5"
                  ></i>
                  <i
                    v-else
                    @click="hideConfirmPass = true"
                    class="cursor-pointer fas fa-eye-slash mg-r-5"
                  ></i>
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="pd-t-5">
            <span class="text-font-14 color-black">
              <el-checkbox v-model="accept"></el-checkbox> ฉันได้อ่าน และยอมรับ
              <span @click="dialogTerm = true" class="text-link"
                >เงื่อนไขการใช้บริการ</span
              >
              และ
              <span @click="dialogPrivacy = true" class="text-link"
                >นโยบายความเป็นส่วนตัว</span
              >
            </span>
          </el-col>
          <el-col :span="24" class="pd-t-3">
            <el-button
              @click="nextToStep"
              type="primary"
              class="width-100 button-auth"
              round
              >ลงทะเบียนเรียนออนไลน์</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-dialog :visible.sync="dialogTerm" class="set-width-modal">
        <h2 class="color-black mg-t-less">เงื่อนไขและข้อตกลงในการใช้บริการ</h2>
        <div class="scroll-inside">
          <p class="text-justify color-black">
            <span class="title-list">1) บทนำ</span>
            เงื่อนไขและข้อตกลงในการใช้บริการ e-Learning by AvocadoX
            นี้เป็นข้อผูกพันระหว่าง “ผู้ใช้บริการ”
            ซึ่งทำการสมัครเรียนผ่านระบบการเรียนแบบออนไลน์
            www.elearning.avocadox.co (ซึ่งต่อไปนี้เรียกว่า “เว็บไซต์”)
            ใช้บริการต่างๆ และหรือเพื่อการสื่อสารใดๆ ตามกรอบที่ “e-Learning by
            AvocadoX” กำหนด ซึ่งต่อไปในข้อตกลงนี้จะเรียกว่า “ผู้ใช้บริการ”
            อีกฝ่ายหนึ่ง กับ e-Learning by AvocadoX
            ซึ่งต่อไปในข้อตกลงนี้จะเรียกว่า “e-Learning by AvocadoX”
            อีกฝ่ายหนึ่ง ทั้งนี้ ภายใต้กรอบวัตถุประสงค์ในการใช้บริการ รวมทั้งการ
            สมัครเรียน เข้าร่วมกิจกรรม หรือซื้อสินค้า ซึ่งในที่นี้รวมถึง
            แต่ไม่จำกัดแค่ วิดีโอคอร์สเรียน, เอกสารประกอบการเรียน, เวิร์คช็อป,
            คำถามและคำตอบ, ใบประกาศนียบัตรออนไลน์ เมื่อ “ผู้ใช้บริการ”
            ตกลงชำระเงิน และหรือล็อกอินเข้าสู่ระบบของ “e-Learning by AvocadoX”
            แล้ว “ผู้ใช้บริการ”
            ตกลงและยินยอมที่จะผูกพันตนรวมทั้งตกลงที่จะปฏิบัติตามเงื่อนไขในการใช้งานผลิตภัณฑ์ของ
            e-Learning by AvocadoX ทุกประการ
            <br />
            <br />** กำหนดนิยามคำว่า “บริการ” “สินค้า”
          </p>
          <p class="text-justify color-black">
            <span class="title-list">2) นโยบายคุ้มครองข้อมูลส่วนบุคคล</span>
            “ผู้ใช้บริการ” เข้าใจว่า “e-Learning by AvocadoX”
            อยู่ภายใต้การกำกับดูแลของบริษัท เยสยูแคน จำกัด การจัดเก็บ รวบรวม
            การใช้ และเปิดเผยข้อมูลส่วนบุคคลจึงเป็นไปตามนโยบายความเป็นส่วนตัวของ
            e-Learning by AvocadoX
          </p>
          <p class="text-justify color-black">
            <span class="title-list">3) เงื่อนไขทั่วไป</span>
            “e-Learning by AvocadoX” ขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข ยกเลิก
            เงื่อนไขการใช้บริการต่างๆ ได้ทุกเมื่อ โดยที่ “ผู้ใช้บริการ”
            จะต้องทำการล็อกอินเข้าสู่ระบบอย่างสม่ำเสมอเพื่อให้มั่นใจว่า
            “ผู้ใช้บริการ” ได้รับรู้ถึงเงื่อนไขล่าสุด
            ที่มีการประกาศและบังคับใช้ในแต่ละช่วงเวลา
            และถือเป็นพันธะสัญญาที่ผู้ใช้บริการต้องถือปฏิบัติโดยเคร่งครัด เมื่อ
            “ผู้ใช้บริการ” ได้ใช้ “บริการ” และหรือกระทำการใดๆที่เกี่ยวข้องกับ
            “สินค้า” หลังจากเงื่อนไขใหม่มีผลบังคับใช้ แล้ว ให้ถือว่า
            “ผู้ใช้บริการ” ได้ยอมรับในเงื่อนไขใหม่นั้นๆ “e-Learning by AvocadoX”
            ขอสงวนสิทธิ์ในการแก้ไข และหรือ ยกเลิก “สินค้า” และหรือ “บริการ” ใดๆ
            ได้ทุกเวลาที่ “ผู้ใช้บริการ” ตกลงเป็นผู้รับผิดชอบต่อค่าใช้จ่ายใดๆ
            เพื่อที่จะทำให้สามารถใช้ “สินค้า” และหรือ “บริการ” ได้ เช่น
            ค่าคอมพิวเตอร์ และ ค่าบริการใช้อินเทอร์เน็ต ในกรณีที่ “ผู้ใช้บริการ”
            ยังไม่ได้ชำระค่าใช้บริการและหรือค่าสินค้าเต็มจำนวน และหรือในจำนวนใดๆ
            “e-Learning by AvocadoX” ขอสงวนสิทธ์ในการป้องกัน
            และหรือกระทำการในประการใดๆ เพื่อมิให้ “ผู้ใช้บริการ” สามารถ
            ใช้บริการนั้นๆ ได้ตามที่ “e-Learning by AvocadoX” เห็นควร การใช้
            “บริการ” จะต้องอยู่ภายใต้บังคับของกฎหมายไทย
            ซึ่งรวมถึงแต่ไม่จำกัดเพียงแค่กฎหมายลิขสิทธิ์
            กฎหมายคุ้มครองทรัพย์สินทางปัญญาใดๆ กฎหมายว่าด้วยความเป็นส่วนตัว และ
            กฎหมายยืนยันหรือบ่งชี้ตัวตน ในการใช้ “สินค้า” และหรือ “บริการ” ใดๆ
            และใช้ “เว็บไซต์” “ผู้ใช้บริการ” ไม่มีสิทธิ์
          </p>
          <ul class="set-sublist">
            <li>
              ดาวน์โหลด, คัดลอก, ทำซ้ำ, เผยแพร่, ดัดแปลง, reverse engineer,
              ปรับเปลี่ยนหน้าตา, ทำลาย, ขโมยข้อมูล, ทำให้ปรากฏต่อสาธารณชน
              และหรือ ขัดขวางการทำงานของ “สินค้า” และ หรือ “บริการ” และเว็บไซต์
            </li>
            <li>
              แสดงตนว่าเป็นบุคคลอื่น หรือให้ข้อมูลส่วนตัวที่ไม่เป็นความจริง
            </li>
            <li>
              ปล่อย virus, worm, spyware, computer code, file หรือ program ใดๆ
              ที่จงใจ หรืออาจจะส่งผลเสีย หรือเข้าไปควบคุม การทำงานของ “สินค้า”
              และหรือ “บริการ” และ “เว็บไซต์”
            </li>
            <li>
              scrape, spider, ใช้ robot, หรือระบบอัตโนมัติอื่นๆ ในการเข้าไปใน
              “สินค้า” และหรือ “บริการ
            </li>
            <li>
              กระทำการใดๆ
              อันขัดต่อประกาศหรือนโยบายที่ระบุไว้ในข้อกำหนดและเงื่อนไขฉบับนี้
              และ/หรือการแก้ไขเพิ่มเติมข้อกำหนดและเงื่อนไขที่จะประกาศหรือกำหนดขึ้นภายหลัง
              หาก “ผู้ใช้บริการ”
              ดำเนินการอย่างหนึ่งอย่างใดอันเป็นการขัดต่อข้อกำหนด
              และเงื่อนไขที่กำหนดในเว็บไซต์นี้ “e-Learning by AvocadoX”
              มีสิทธิที่จะระงับการให้บริการโดยไม่บอกกล่าวล่วงหน้าและ/หรือดำเนินการในทางกฎหมายตามที่เห็นสมควร
            </li>
          </ul>
          <p class="text-justify color-black">
            <span class="title-list">4) ลิขสิทธิ์ตามกฎหมาย</span>
            “e-Learning by AvocadoX” ขอแจ้งให้ “ผู้ใช้บริการ” ทราบว่า ข้อความ
            ภาพ เสียง วิดีโอ เนื้อหา เครื่องหมายการค้า เครื่องหมายบริการ ชื่อ
            ชื่อทางการค้า สิทธิบัตร Know how ฯลฯ ทั้งหมดที่ปรากฏใน “เว็บไซต์”
            เป็นของบริษัท เยสยูแคน จำกัด เป็นงานอันได้รับความคุ้มครองตามกฎหมาย
            ห้ามมิให้บุคคลใดลอกเลียน ปลอมแปลง ทำซ้ำ คัดลอก ดัดแปลง
            เผยแพร่ต่อสาธารณชน จำหน่าย มีไว้ให้เช่าหรือ กระทำการใดๆ
            ในลักษณะที่เป็นการแสวงหาประโยชน์ ทางการค้าหรือ ประโยชน์โดยมิชอบ
            ไม่ว่าโดยประการใดๆ จากทรัพย์สินทางปัญญาดังกล่าวข้างต้น
            โดยไม่ได้รับอนุญาตล่วงหน้าเป็นลายลักษณ์อักษรจาก e-Learning by
            AvocadoX
          </p>
          <p class="text-justify color-black">
            <span class="title-list">5) การใช้งาน</span>
            “ผู้ใช้บริการ” จะใช้ “สินค้า” และหรือ “บริการ”
            ด้วยตนเองเพื่อการเรียนรู้เฉพาะตนเท่านั้น “ผู้ใช้บริการ”
            ตกลงที่จะไม่ใช้ “สินค้า” และหรือ “บริการ” หรือติดต่อ “ผู้สอน”
            เพื่อประโยชน์ทางธุรกิจใดๆ โดยไม่ได้รับอนุญาตจาก “e-Learning by
            AvocadoX” เป็นลายลักษณ์อักษรก่อน ซึ่งรวมถึงแต่ไม่จำกัดแค่การว่าจ้าง
            และ การเรี่ยไรเงินและหรือทรัพย์สิน
            และหรือการขอรับการสนับสนุนทางการเงินและหรือทาง
          </p>
          <span class="title-list"
            >6) ข้อตกลงและคำรับรองของ “ผู้ใช้บริการ”</span
          >
          <ul class="set-sublist">
            <li>
              “ผู้ใช้บริการ” ได้อ่านและเข้าใจ และตกลงยอมรับราคา
              ตลอดจนรายละเอียดต่างๆของ “สินค้า” และหรือ “บริการ”
              ก่อนที่จะชำระเงินซื้อ “สินค้า”และหรือ “บริการ” นั้นๆ ในกรณีของ
              “ผู้ใช้บริการ” และหรือ “ผู้ซื้อสินค้า” ที่มีอายุน้อยกว่า 18 ปี
              “ผู้ใช้บริการ” และหรือ “ผู้ซื้อสินค้า” ตกลงและรับรองว่า
              “ผู้ใช้บริการ” และหรือ “ผู้ซื้อสินค้า”
              ได้รับความยินยอมจากผู้ปกครองก่อนที่จะชำระเงินซื้อ “สินค้า” และหรือ
              “บริการ” นี้แล้ว
            </li>
            <li>
              “ผู้ใช้บริการ” จะไม่นำ “สินค้า” และหรือ “บริการ” ไปทำซ้ำ ดัดแปลง
              ลอกเลียน ปลอมแปลง ทำเหมือน ตัดต่อ และหรือเผยแพร่ในประการใดๆ
            </li>
            <li>
              ผู้ใช้บริการ” จะไม่ขอข้อมูลใดๆ จาก “ผู้สอน” และหรือ
              ผู้ใช้บริการคนอื่นๆ
            </li>
            <li>
              “ผู้ใช้บริการ” สามารถใช้ “สินค้า” และหรือ “บริการ”
              ที่ตนซื้อได้เพียงเฉพาะเพื่อตนเองเท่านั้น “ผู้ใช้บริการ”
              ไม่สามารถนำ “สินค้า” และหรือ “บริการ”
              ที่ตนซื้อไปให้บุคคลอื่นใดใช้และหรือใช้ร่วมได้
            </li>
            <li>
              ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน
              หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใด ๆ
              ผู้ใช้บริการต้องดำเนินการแจ้งให้ “e-Learning by AvocadoX”
              ทราบทันทีตามวิธีการที่“e-Learning by AvocadoX” กำหนด อย่างไรก็ตาม
              การดำเนินการต่าง ๆ ข้างต้นจะไม่มีผลกระทบต่อกิจกรรมใด ๆ
              ที่ได้ดำเนินการไปแล้วก่อนการแจ้งให้“e-Learning by AvocadoX” ทราบ
            </li>
          </ul>
          <p class="text-justify color-black">
            <span class="title-list">7) การสมัครสมาชิก</span>
            “ผู้ใช้บริการ” จะต้องสมัครสมาชิกก่อนที่จะซื้อสินค้าได้ โดย
            “ผู้ใช้บริการ” และหรือ “ผู้ซื้อสินค้า”
            มีความรับผิดชอบเป็นการเฉพาะตนที่จะต้องทำการเก็บรักษารหัสผ่านไว้เป็นความลับ
            และต้องไม่เปิดเผยต่อบุคคลใดๆ ไม่ว่าเพื่อวัตถุประสงค์ใด
            “ผู้ใช้บริการ”
            จะต้องให้ข้อมูลที่เป็นความจริงและเป็นปัจจุบันในการสมัครสมาชิก
            “ผู้ใช้บริการ” ไม่สามารถโอนความเป็นสมาชิกของตนให้กับผู้อื่น และ
            “ผู้ใช้บริการ”
            ไม่สามารถใช้อีเมลของผู้อื่นในการเข้าไปใช้บริการและหรือซื้อสินค้าได้
            “ผู้ใช้บริการ” ไม่สามารถเปลี่ยนอีเมลบัญชีผู้ใช้
            หากจำเป็นต้องโอนคอร์สเรียนที่ได้ทำการสมัครเรียนไปยังอีเมลบัญชีอื่น
            “ผู้ใช้บริการ” ต้องทำการยื่นคำร้องมาที่ “e-Learning by AvocadoX"
            โดยการพิจารณาของทีมงาน “e-Learning by AvocadoX”
            ถือเป็นที่สิ้นสุด“ผู้ใช้บริการ” เข้าใจว่าข้อมูลของ “ผู้ใช้บริการ”
            ซึ่งรวมถึง ข้อมูลคอร์สเรียนที่ “ผู้ใช้บริการ” ได้สมัครเรียน
            จะถูกบันทึกกับบัญชีผู้ใช้ หากมีการเปลี่ยนเปลี่ยนบัญชีผู้ใช้ ทาง
            “e-Learning by AvocadoX” จะไม่รับผิดชอบ
            ผลกระทบจากการเปลี่ยนอีเมลบัญชีผู้ใช้
          </p>
          <p class="text-justify color-black">
            <span class="title-list">8) ขอบเขตความรับผิดชอบ</span>
            ขอบเขตความรับผิดชอบของ “e-Learning by AvocadoX”
            จะถูกจำกัดแค่จำนวนเงินที่ “ผู้ใช้บริการ” ได้ชำระเพื่อซื้อ “สินค้า”
            และหรือ ”บริการ” เท่านั้น
          </p>
          <p class="text-justify color-black">
            <span class="title-list">9) การยกเลิกการใช้สินค้า</span>
            หาก “ผู้ใช้บริการ” ทำผิดเงื่อนไขในการใช้ ”สินค้า” และหรือ “บริการ”
            ในข้อใดๆ “e-Learning by AvocadoX” สามารถเพิกถอนและหรือระงับการใช้
            “สินค้า” และหรือ “บริการ” ของ “ผู้ใช้บริการ”
            ได้ทันทีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            อีกทั้งผู้ใช้บริการและหรือผู้ซื้อสินค้าตกลงและยินยอมให้ “e-Learning
            by AvocadoX” ริบเงินที่ได้ชำระไว้แล้วได้ในทันที
          </p>
          <!-- <p class="text-justify color-black pd-t-2">
            สามารถอ่านข้อมูลเพิ่มเติมได้ที่
            <a
              class="color-primary"
              href="https://www.tat.or.th/th/term-condition"
              target="_blank"
              >https://www.tat.or.th/th/term-condition</a
            >
          </p> -->
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogPrivacy" class="set-width-modal">
        <h2 class="color-black mg-t-less">นโยบายความเป็นส่วนตัว</h2>
        <div class="scroll-inside">
          <p class="text-justify color-black">
            “e-Learning by AvocadoX” อยู่ภายใต้การกำกับดูแลของบริษัท เยสยูแคน
            จำกัด การจัดเก็บ รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลจึงเป็นไปตาม
            นโยบายความเป็นส่วนตัว e-Learning by AvocadoX”
            จะเก็บรวบรวมและใช้ข้อมูลที่เกี่ยวข้องกับ ผู้ใช้บริการ
            เฉพาะสำหรับกิจการที่ได้กำหนดไว้ในนโยบายความเป็นส่วนตัวนี้เท่านั้น
            และเก็บรักษาข้อมูลของผู้ใช้บริการ
            ไว้เป็นระยะเวลาตราบเท่าที่กฎหมายกำหนด
            หรือเป็นระยะเวลาตามวัตถุประสงค์ในการเก็บข้อมูลนั้นๆ
          </p>
          <p class="text-justify color-black">
            โดยวัตถุประสงค์ของเอกสารฉบับนี้ (“นโยบายความเป็นส่วนตัว”)
            เพื่อแจ้งวิธีการที่ “e-Learning by AvocadoX” เก็บรวบรวม ประมวลผล และ
            ใช้ “ข้อมูลส่วนบุคคล” (ตามที่ได้นิยามในเอกสารฉบับนี้)
            ของผู้ใช้บริการที่เกี่ยวกับการสมัครใช้บริการระบบการเรียนแบบออนไลน์
            ระบบทดสอบ ใบประกาศนียบัตร รวมทั้งบริการที่เกี่ยวข้องกับผู้ใช้บริการ
            (รวมเรียกว่า “บริการ”) ที่จะเกิดมีขึ้นใน “เว็บไซต์” นี้เป็นการเฉพาะ
            ภายใต้บทบัญญัติของกฎหมายที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคล
            ทีมงาน “e-Learning by AvocadoX”
            แนะนำให้ผู้ใช้บริการได้โปรดอ่านนโยบายความเป็นส่วนตัวฉบับนี้
            เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่ทีมงาน “e-Learning by
            AvocadoX” ได้เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ
          </p>
          <p class="text-justify color-black">
            โดยการที่ผู้ใช้บริการได้เริ่มปฏิสัมพันธ์กับ “e-Learning by
            AvocadoX”ส่งข้อมูลให้แก่ “e-Learning by AvocadoX”
            หรือลงทะเบียนเพื่อใช้ “บริการ” ของ “e-Learning by AvocadoX”
            ถือว่าผู้ใช้บริการได้ตกลงและยินยอมให้ “e-Learning by AvocadoX” ,
            บริษัท เยสยูแคน จำกัด และผู้แทน และ/หรือตัวแทนที่เกี่ยวข้อง
            (ต่อไปในเอกสารนี้ รวมเรียกว่า “ทีมงาน”, “เรา” หรือ “พวกเรา”)
            เก็บรวบรวม ใช้ เปิดเผย และเผยแพร่ข้อมูลส่วนบุคคลของ “ผู้ใช้บริการ”
            รวมถึงเปิดเผยข้อมูลส่วนบุคคลดังกล่าวต่อ “ผู้ใช้บริการ”
            ที่ได้รับมอบอำนาจของทีมงาน และบุคคลภายนอกที่เกี่ยวข้อง
            ตามที่ได้กำหนดไว้ในนโยบายความเป็นส่วนตัวฉบับนี้
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >การเก็บข้อมูลของผู้ใช้โดยทีมงาน (Personal Information Collected
              by Organization)</span
            >
            เมื่อผู้ใช้บริการได้สมัครใช้บริการ เพื่อใช้บริการของทีมงาน
            หรือได้ใช้บริการ เข้าถึงบริการ ทีมงาน อาจจะร้องขอให้
            ผู้ใช้บริการให้ข้อมูลส่วนบุคคลของผู้ใช้บริการรวมทั้งข้อมูลที่ไม่เปิดเผยชื่อ
            สำหรับการให้บริการดังกล่าว ซึ่งทีมงาน
            เห็นว่าจำเป็นและเป็นประโยชน์ของผู้ใช้บริการและในการให้บริการ
            และข้อมูลส่วนบุคคลที่จำเป็นในการให้บริการ
            และอาจจะเป็นการบ่งชี้ตัวตนของผู้ใช้ไม่ว่าโดยทางตรงหรือทางอ้อม
            (รวมเรียกว่า “ข้อมูลส่วนบุคคล”) ได้แก่
          </p>
          <ul class="set-sublist">
            <li>
              ข้อมูลการลงทะเบียนของผู้ใช้บริการ ได้แก่ ชื่อ-นามสกุล,
              หมายเลขโทรศัพท์, ที่อยู่อีเมล ตำแหน่งงาน องค์กรที่สังกัด
              และ/หรือข้อมูลส่วนบุคคลอื่นๆ
            </li>
            <li>
              ข้อมูลที่ผู้ใช้บริการให้ไว้บนเว็บไซต์ และแอปพลิเคชันของเรา เช่น
              การรับบริการต่างๆ ผ่านทางแอพพลิเคชั่น
            </li>
            <li>
              ข้อมูลที่เราได้รับจากบุคคลภายนอก เช่น
              ผู้ให้บริการเว็บไซต์หรือแพลตฟอร์ม
              เกี่ยวกับการใช้แอปพลิเคชันของเราบนแพลตฟอร์มหรืออุปกรณ์ของบุคคลภายนอก
            </li>
            <li>
              ข้อมูลการใช้งาน ข้อมูลการดู ข้อมูลทางเทคนิค
              และข้อมูลอุปกรณ์เมื่อคุณเข้าชมเว็บไซต์ และใช้แอปพลิเคชัน
              หรือเปิดอีเมลที่เราส่ง รวมถึงประเภทของเบราว์เซอร์หรืออุปกรณ์
              รหัสตัวระบุอุปกรณ์ที่ไม่ซ้ำกัน และที่อยู่ IP ของผู้ใช้บริการ
            </li>
          </ul>
          <p class="text-justify color-black">
            ผู้ใช้บริการอาจตัดสินใจว่าจะส่งข้อมูลส่วนบุคคลให้แก่ทีมงาน หรือไม่
            หากผู้ใช้บริการไม่ส่งข้อมูลส่วนบุคคลตามที่จำเป็นให้แก่ทีมงาน ทีมงาน
            อาจพิจารณาปฏิเสธการขอสมัครเป็นผู้ใช้บริการหรือปฏิเสธที่จะให้บริการส่วนใดส่วนหนึ่งหรือทั้งหมดแก่ผู้ใช้บริการ
            ผู้ใช้บริการควรจะตรวจสอบว่าข้อมูลส่วนบุคคลที่ได้ส่งให้ทีมงาน
            นั้นครบถ้วน เป็นจริงและถูกต้อง
            หากผู้ใช้บริการมิได้ตรวจสอบข้อมูลส่วนบุคคลดังกล่าว อาจจะทำให้ทีมงาน
            ไม่สามารถให้บริการตามที่ผู้ใช้ร้องขอได้
            ซึ่งผู้ใช้บริการรับประกันและรับรองว่า
            ผู้ใช้อนุญาตให้ข้อมูลส่วนบุคคลแก่ทีมงาน เพื่อเก็บรวบรวม ประเมินผล
            และใช้ข้อมูลส่วนบุคคลดังกล่าวตามบทบัญญัติของกฎหมายที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคล
            นโยบายความเป็นส่วนตัวฉบับนี้ และนโยบายความเป็นส่วนตัวของบริษัท
            เยสยูแคน จำกัด
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >วัตถุประสงค์ของการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลของผู้ใช้
              (Purpose for Collection, Use and Disclosure of Personal
              Information)</span
            >
            ทีมงาน อาจจะเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้ รวมถึง
            แต่ไม่จำกัดเฉพาะเพื่อวัตถุประสงค์ดังต่อไปนี้
          </p>
          <ul class="set-sublist">
            <li>
              เพื่อดำเนินการหรือสนับสนุนการให้บริการแก่ผู้ใช้บริการ (รวมถึง
              แต่ไม่จำกัดเฉพาะ การปรับซอฟต์แวร์ (software upgrades)
              และปรับปรุงการให้บริการ) รวมถึงทำให้ทีมงาน
              รับมือกับคำถามของผู้ใช้บริการได้อย่างมีประสิทธิภาพ
            </li>
            <li>
              เพื่อสื่อสารและให้ข้อมูลเกี่ยวกับการพัฒนาการให้บริการใหม่ๆ ในอนาคต
              รวมทั้งติดต่อกับผู้ใช้ตามที่ทีมงาน เห็นว่าจำเป็น
            </li>
            <li>
              ทำวิจัยและวิเคราะห์ข้อมูลเพื่อให้เราสามารถเข้าใจถึงความต้องการของผู้ใช้บริการ
              และนำมาพัฒนา
              ปรับปรุงบริการให้ดีเหมาะสมกับความต้องการของผู้ใช้บริการ
            </li>
            <li>
              เพื่อตรวจสอบการสมัครใช้บริการของผู้ใช้บริการ
              เพื่อใช้ในการตัดสินใจว่าจะตอบรับการสมัครใช้บริการดังกล่าวหรือไม่
              รวมทั้งการตรวจสอบตัวตน เมื่อทีมงาน ได้รับคำร้องขอ
              หรือคำสั่งจากผู้ใช้บริการ
            </li>
            <li>
              ป้องกันมิให้เกิดการฉ้อโกง หรือไม่ได้รับอนุญาตใดๆ ในการใช้บริการ
            </li>
            <li>
              ป้องกัน ตรวจจับ และสอบสวนอาชญากรรม และวิเคราะห์
              รวมถึงจัดการความเสี่ยงในเชิงพาณิชย์
              และดำเนินการสอบสวนเกี่ยวกับข้อพิพาท การเรียกเก็บค่าสินค้า/บริการ
              (billing) หรือการฉ้อโกงใดๆ
            </li>
            <li>
              ในกรณีข้อเรียกร้อง การกระทำ หรือกระบวนการพิจารณาใดๆ (รวมถึง
              แต่ไม่จำกัดเฉพาะ การร่าง และการตรวจสอบเอกสาร เอกสารการทำธุรกรรม
              การได้รับความเห็นทางกฎหมาย และดำเนินคดี) และ/หรือ ปกป้อง
              และบังคับสิทธิและหน้าที่ตามสัญญาของทีมงาน
            </li>
            <li>
              เพื่อให้เป็นไปตามและปฏิบัติตามกฎหมาย ระเบียบ กฎ หลักปฏิบัติ
              หรือแนวทางปฏิบัติใดๆ
              ที่ออกโดยหน่วยงานตามกฎหมายหรือที่มีอำนาจกำกับดูแล ซึ่งทีมงาน
              มีหน้าที่ต้องปฏิบัติตาม (รวมถึง แต่ไม่จำกัดเฉพาะ
              การตอบข้อร้องเรียนของหน่วยงานกำกับดูแล
              การเปิดเผยต่อหน่วยงานกำกับดูแล และการตรวจสอบทางบัญชี
              การตรวจสอบในเชิงลึก และการสอบสวน) และ/หรือ
              กระทำการอื่นใดที่จำเป็นในการให้บริการ
            </li>
          </ul>
          <p class="text-justify color-black">
            นอกจากนี้ ในกรณีที่บทบัญญัติของกฎหมายที่เกี่ยวข้องอนุญาต ทีมงาน
            อาจจะเก็บรวบรวม ใช้ ประมวลผล
            และ/หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์เพิ่มเติมดังต่อไปนี้
          </p>
          <ul class="set-sublist">
            <li>ให้ข้อมูลเกี่ยวกับบริการและข้อมูลการโฆษณาจากทีมงาน</li>
            <li>
              จัดหรือทำการตลาดเกี่ยวกับบริการโดยทั่วไป ผลิตภัณฑ์
              และสิทธิประโยชน์แก่ผู้ใช้ รวมถึง
              แต่ไม่จำกัดเฉพาะงานหรือข้อเสนอพิเศษใดๆ จากทีมงาน
            </li>
            <li>
              วัตถุประสงค์อื่นใดตามที่สมเหตุสมผลกับวัตถุประสงค์ที่ได้ระบุข้างต้น
            </li>
          </ul>
          <p class="text-justify color-black">
            ทีมงาน อาจจะใช้ข้อมูลส่วนบุคคลของผู้ใช้บริการ
            เพื่อวัตถุประสงค์อื่นใด นอกไปจากที่ได้ระบุไว้ในนโยบายฉบับนี้
            โดยอยู่ภายใต้กฎหมายและระเบียบที่เกี่ยวข้อง
          </p>

          <p class="text-justify color-black">
            <span class="title-list"
              >การมอบหมายข้อมูล (Information Delegation)</span
            >
            ทีมงาน อาจจะให้ข้อมูลส่วนบุคคลแก่
            บุคคลหรือนิติบุคคลผู้รับจ้างภายใต้สัญญา และ/หรือตัวแทน หาก
            บุคคลหรือนิติบุคคลผู้รับจ้างภายใต้สัญญา
            และ/หรือตัวแทนได้รับมอบหน้าที่จากทีมงาน
            ในการให้บริการส่วนใดส่วนหนึ่ง ทั้งนี้ ทีมงาน
            จะจัดให้บุคคลหรือนิติบุคคลผู้รับจ้างภายใต้สัญญา
            และ/หรือตัวแทนปฏิบัติตามนโยบายฉบับนี้
            เพื่อปกป้องข้อมูลส่วนบุคคลของผู้ใช้บริการ
          </p>
          <p class="text-justify color-black">
            นอกจากนี้ ผู้ใช้บริการยอมรับและตกลงว่า ทีมงาน
            อาจจะมอบหมายให้ผู้ให้บริการภายนอกจัดการข้อมูลส่วนบุคคลที่เก็บรวบรวมจากผู้ประกอบการร้านค้า
            ไม่ว่าจะทั้งหมดหรือบางส่วน ในการให้บริการ โดยทีมงาน
            จะคำนึงถึงความจำเป็นเพื่อการบรรลุวัตถุประสงค์ในการใช้บริการ
            (“ผู้ให้บริการภายนอก”) ในกรณีเช่นว่า ทีมงาน จะดำเนินการ
            เพื่อทำให้แน่ใจได้ว่าผู้ให้บริการภายนอกอยู่ภายใต้กฎหมายและระเบียบที่เกี่ยวข้อง
            รวมถึงประเมินคุณสมบัติ
            และความสามารถของผู้ให้บริการภายนอกอย่างเพียงพอ
            กำหนดข้อสัญญาว่าด้วยการรักษาความลับในสัญญาว่าจ้างที่ทำกับผู้ให้บริการภายนอก
            พร้อมทั้งจัดตั้งระบบการบริหารจัดการข้อมูลอย่างเหมาะสม
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >การใช้ข้อมูลระหว่างกัน (Shared Use of Information)</span
            >
            ระหว่างระยะเวลาที่ผู้ใช้ใช้บริการทีมงาน และ/หรือ
            ผู้ให้บริการภายนอกอาจจะประมวลผล
            และใช้ข้อมูลส่วนบุคคลของผู้ใช้บริการในรูปแบบเอกสารที่พิมพ์ขึ้น
            (printed document) และ/หรือในรูปแบบอิเล็กทรอนิกส์ (soft files)
            หรือรูปแบบอื่นใด ไม่ว่าจะภายในหรือภายนอกประเทศไทย
          </p>

          <span class="title-list"
            >การใช้ข้อมูลระหว่างกัน (Shared Use of Information)</span
          >
          <ul class="set-sublist">
            <li>การใช้คุกกี้ (Cookies)</li>
          </ul>
          <p class="text-justify color-black">
            เพื่อการให้บริการที่ดีที่สุดเท่าที่จะทำได้แก่ผู้ใช้บริการ
            และเพื่อวัตถุประสงค์ในการบำรุงรักษาและรักษาความมั่นคงปลอดภัย คุกกี้
            (Cookies) จะถูกใช้เพื่อเก็บรูปแบบการตั้งค่าของผู้ใช้ (user settings)
            เพื่อบันทึกลักษณะการเข้าถึง และตรวจสอบสถิติและรูปแบบการใช้งานต่างๆ
            ผู้ใช้บริการสามารถเลือกที่จะไม่รับการต่อเชื่อมคุกกี้ได้
            ซึ่งจะส่งผลให้ผู้ใช้ไม่สามารถใช้บริการบางส่วนที่จำเป็นต้องต่อเชื่อมคุกกี้
            ทั้งนี้ ผู้ใช้บริการสามารถอ่านและศึกษา ได้ที่นโยบายการใช้งานคุกกี้
          </p>
          <ul class="set-sublist">
            <li>บันทึกผู้เข้าชมเว็บ (Logs)</li>
          </ul>
          <p class="text-justify color-black">
            หลังจากที่ผู้ใช้ได้เข้าถึงบริการ ระบบจะเก็บบันทึกหมายเลขไอพี (IP
            Address) ประเภทของโปรแกรมบราวเซอร์ (Browser Type) และภาษาบราวเซอร์
            (Browser Language) ฯลฯ ของผู้ใช้ไว้ที่แพลทฟอร์ม (Platform) ของทีมงาน
            โดยอัตโนมัติ (“แพลทฟอร์ม”)
            เพื่อให้เป็นไปตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลและกฎหมายว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์
            โดยข้อมูลเหล่านี้จะใช้เพื่อการวิเคราะห์สภาพแวดล้อมผู้ใช้บริการ (user
            environment) ซึ่งจะทำให้ทีมงาน สามารถพัฒนาบริการให้ดีขึ้นได้
            และป้องกันมิให้เกิดการฉ้อโกงหรือไม่ได้รับอนุญาตใดๆ
            อันเป็นเหตุรบกวนการดำเนินการให้บริการตามปกติ
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >สิทธิของผู้ใช้บริการ (Platform Operator's and the Personnel's
              Rights)</span
            >
            ผู้ใช้บริการอาจจะยืนยัน เพิ่มเติม
            หรือแก้ไขข้อมูลส่วนบุคคลของตนเองที่ได้ลงทะเบียนไว้ในการใช้บริการ
            ไม่ว่าในเวลาใดๆ
          </p>
          <p class="text-justify color-black">
            ผู้ใช้อาจจะขอดู หรือร้องขอสำเนาข้อมูลส่วนบุคคลของตนที่ทีมงาน
            ได้เก็บรวบรวมไว้จากทีมงาน โดยการติดต่อทีมงาน
            ตามวิธีที่กำหนดไว้ท้ายนโยบายฉบับนี้
          </p>
          <p class="text-justify color-black">
            ผู้ใช้บริการอาจจะส่งคำร้องขอให้ทีมงาน แก้ไข
            หรือเพิ่มเติมข้อมูลส่วนบุคคลของตน โดยการติดต่อทีมงาน
            ตามวิธีที่กำหนดไว้ท้ายนโยบายฉบับนี้
            หากผู้ใช้บริการและ/หรือผู้มีอำนาจกระทำการพบว่า
            ข้อมูลส่วนบุคคลที่ได้ลงทะเบียนไว้กับทีมงาน ได้เปลี่ยนแปลงไป
            หรือไม่ถูกต้อง ผู้ใช้บริการอาจจะร้องขอให้ทีมงาน ลบ
            หรือยกเลิกการเก็บรวบรวม การประมวลผล
            หรือการใช้ข้อมูลส่วนบุคคลดังกล่าว
            เว้นแต่กฎหมายและระเบียบที่เกี่ยวข้องอนุญาตให้ทีมงาน
            ดำเนินการเก็บรักษา ประมวลผล ใช้
            และ/หรือเปิดเผยข้อมูลส่วนบุคคลได้ต่อไป
          </p>
          <p class="text-justify color-black">
            เมื่อผู้ใช้ร้องขอการเข้าถึงข้อมูลส่วนบุคคลของตนเอง
            (รวมถึงขอสำเนาข้อมูลส่วนบุคคลของตน)
            ซึ่งผู้ใช้ไม่สามารถยืนยัน/เข้าถึง ผ่านการใช้บริการได้ ทีมงาน
            อาจจะเก็บค่าธรรมเนียมจากผู้ใช้ในการเปิดเผยข้อมูล
            ผู้ใช้มีสิทธิเลือกว่าจะให้ข้อมูลส่วนบุคคลกับทีมงาน หรือไม่
            อย่างไรก็ตาม ผู้ใช้อาจจะไม่สามารถใช้บริการบางส่วนได้
            จนกว่าจะได้ให้ข้อมูลตามที่จำเป็นแก่ทีมงาน
          </p>
          <p class="text-justify color-black">
            <span class="title-list">การอัพเดทข้อมูลส่วนบุคคลของท่าน</span>
            ผู้ใช้บริการสามารถอัพเดทข้อมูลส่วนบุคคลของได้ทุกเมื่อ
            เพียงเข้าสู่ระบบด้วยบัญชีผู้ใช้บนเว็บไซต์และแอปพลิเคชันของทีมงาน
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >การยกเลิกบริการ (Withdrawal from the Services)</span
            >
            หากผู้ใช้บริการตัดสินใจยกเลิกบัญชีสำหรับบริการ
            และจะไม่ใช้บริการต่อไปอีก ข้อมูลทั้งหมด (รวมถึง
            แต่ไม่จำกัดเฉพาะข้อมูลส่วนบุคคล)
            ที่เกี่ยวกับผู้ใช้บริการรวมถึงข้อมูลที่เกี่ยวกับผู้ใช้บริการ
            ดังกล่าวจะได้รับการจัดการตามกฎหมายและระเบียบที่เกี่ยวข้อง
            นโยบายฉบับนี้ และนโยบายอื่นๆ ของทีมงาน อย่างไรก็ตาม
            การยกเลิกดังกล่าวจะไม่ถือว่าเป็นการเพิกถอนการอนุญาตที่ได้ให้ทีมงาน
            ใช้และเปิดเผยข้อมูลดังกล่าว เว้นแต่จะได้ระบุไว้เป็นอย่างอื่น
            เป็นลายลักษณ์อักษร และได้รับอนุญาตภายใต้กฎหมายที่เกี่ยวข้อง
          </p>
          <p class="text-justify color-black">
            หากผู้ใช้บริการ เพิกถอนการอนุญาตในการใช้ข้อมูลส่วนบุคคล
            ไม่ว่าทั้งหมดหรือส่วนใดส่วนหนึ่ง ขึ้นอยู่กับลักษณะของคำขอ ทีมงาน
            อาจจะไม่อยู่ในสถานะที่จะดำเนินการให้บริการแก่ผู้ใช้บริการได้ต่อไป
            หรือบริหารจัดการนิติสัมพันธ์ที่มีอยู่ได้
            ซึ่งอาจเป็นเหตุแห่งการยกเลิกสัญญากับทีมงาน
            และถือว่าผู้ใช้บริการผิดสัญญาหรือคำรับรองตามสัญญา ทีมงาน
            ขอสงวนสิทธิ์และการเยียวยาตามกฎหมายไว้อย่างชัดแจ้ง
          </p>
          <p class="text-justify color-black">
            <span class="title-list">ข้อมูลการชำระเงิน</span>
            บริการของทีมงาน สามารถชำระเงินได้ผ่านช่องทางต่างๆ เช่น
            การโอนเงินเข้าบัญชีธนาคาร หรือบัตรเครดิต
            โดยผู้ใช้บริการต้องให้ข้อมูลส่วนตัวของบัตรเครดิต ทั้งนี้
            เพื่ออำนวยความสะดวกในการใช้จ่ายซื้อสินค้าและบริการผ่านระบบของทีมงาน
            เท่านั้น ทีมงาน
            ไม่มีนโยบายการเก็บข้อมูลบัตรเครดิตของผู้ใช้บริการไม่ว่าด้วยวิธีการใดๆ
            ทั้งการบันทึกลงฐานข้อมูล Logs หรืออื่นๆ โดยทีมงาน มีการใช้งาน
            payment gateway ในการรับชำระเงินจากผู้ใช้บริการ
            โดยมีการเข้ารหัสตามหลักมาตรฐานความปลอดภัย PCI-DSS
            ตามการรับรองของผู้ให้บริการ payment gateway
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >เว็บไซต์ของบุคคลที่สาม (Third Party Application)</span
            >มีลิงก์ไปยังเว็บไซต์ของบุคคลที่สาม แต่ทีมงาน
            จะไม่รับผิดชอบต่อหลักปฏิบัติเรื่องความเป็นส่วนตัวของเว็บไซต์ของบุคคลที่สาม
            เมื่อผู้ใช้บริการเลิกหรือหยุดใช้บริการของทีมงาน
            เราขอแนะนำให้อ่านแถลงการณ์/นโยบายความเป็นส่วนตัวของเว็บไซต์บุคคลที่สามทุกๆ
            เว็บที่รวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการ
          </p>
          <p class="text-justify color-black">
            ทีมงาน
            มีตัวเลือกให้ผู้ใช้บริการส่งออกข้อมูลไปยังแอปพลิเคชันและเว็บไซต์ของบุคคลที่สาม
            รวมถึงไซต์เครือข่ายสังคม ซึ่งรวมถึงแต่ ไม่จำกัดเฉพาะ Facebook,
            Twitter หรือ LinkedIn เมื่อส่งออกข้อมูลดังกล่าว
            แสดงว่าผู้ใช้บริการอาจกำลังเปิดเผยข้อมูลของผู้ใช้บริการให้กับบุคคลอื่นหรือองค์กรอื่นที่รับผิดชอบด้านการดำเนินการและบำรุงรักษาแอปพลิเคชันและไซต์ของบุคคลที่สาม
            บุคคลอื่นที่เข้ามาดูหรือใช้แอปพลิเคชันหรือไซต์เหล่านั้นอาจเข้าถึงข้อมูลของผู้ใช้บริการได้
            เราไม่ได้เป็นเจ้าของหรือดูแลจัดการแอปพลิเคชันหรือเว็บไซต์ที่ผู้ใช้เชื่อมต่อ
            เราจึงขอแนะนำให้ผู้ใช้บริการระมัดระวังเกี่ยวกับการเปิดเผยข้อมูลส่วนตัวในลักษณะนี้
            และผู้ใช้บริการควรทบทวนนโยบายความเป็นส่วนตัวของเว็บไซต์นั้นเพื่อรับรองว่าผู้ใช้พอใจกับวิธีที่เว็บไซต์
            เหล่านั้นใช้ข้อมูลที่ผู้ใช้มอบให้กับพวกเขา
          </p>
          <p class="text-justify color-black">
            <span class="title-list">การใช้งาน Google Analytics</span> ทีมงาน
            มีการใช้งาน Google Analytics
            เพื่อเรียกดูข้อมูลการใช้งานของผู้ใช้บริการ รวมถึง
            แต่ไม่จำกัดเฉพาะข้อมูลของเบราเซอร์ ข้อมูลของอุปกรณ์ ประเทศที่อยู่
            เพื่อจุดประสงค์ในการพัฒนาปรับปรุงประสบการณ์การใช้งานแพลตฟอร์มให้ดียิ่งขึ้น
            รวมถึงนำข้อมูลพฤติกรรมการใช้งานเพื่อการนำเสนอและโฆษณาสินค้าและบริการของทีมงาน
            ที่เหมาะสมกับผู้ใช้บริการแต่ละราย
            โดยไม่มีการเปิดเผยข้อมูลดังกล่าวให้กับบุคคลอื่นใดนอกเหนือจากใช้งานภายในทีมงาน
          </p>
          <p class="text-justify color-black">
            หากผู้ใช้บริการไม่ต้องการให้ Google Analytics
            สามารถเข้าถึงข้อมูลการใช้งานของผู้ใช้บริการได้
            สามารถเลือกที่จะปิดการบันทึกการใช้งานผ่านการตั้งค่า Cookies
            หรือผ่านเครื่องมือของ Google ทาง
            <a
              class="color-primary"
              href="https://tools.google.com/dlpage/gaoptout/"
              target="_blank"
              >https://tools.google.com/dlpage/gaoptout/</a
            >
          </p>
          <p class="text-justify color-black">
            <span class="title-list">การใช้งาน Hotjar</span>
            ทีมงาน ใช้งาน Hotjar
            เพื่อทำความเข้าใจความต้องการของผู้ใช้บริการและปรับปรุงประสบการณ์การให้บริการให้ดียิ่งขึ้น
            ผ่านการเก็บบันทึกพฤติกรรมการใช้งานแพลตฟอร์ม เช่น
            ระยะเวลาที่ใช้ในการดูข้อมูลแต่ละหน้า การกดลิงค์ การกดปุ่ม
            หรือการบันทึกวีดิโอหน้าจอขณะกำลังใช้งาน Hotjar
            มีการใช้งานคุกกี้และเทคโนโลยีอื่นในการเก็บบันทึกข้อมูลการใช้งานของผู้ใช้บริการ
            ประเภทของอุปกรณ์ ขนาดของอุปกรณ์ IP address ของอุปกรณ์
            ข้อมูลของเบราเซอร์ ประเทศที่อยู่ ภาษาที่ใช้งาน โดย Hotjar
            ไม่มีนโยบายในการเก็บข้อมูลที่เป็นส่วนตัว เช่น หมายเลขโทรศัพท์
            หมายเลขบัตรเครดิต และไม่มีนโยบายในการขายข้อมูลดังกล่าวให้กับบุคคลใด
          </p>
          <p class="text-left color-black">
            สามารถดูรายละเอียดเพิ่มเติมเกี่ยวกับ Hotjar ได้ทางเว็บไซต์
            <a
              class="color-primary"
              href="https://help.hotjar.com/hc/en-us/categories/115001323967-About-Hotjar"
              target="_blank"
              >https://help.hotjar.com/hc/en-us/categories/115001323967-About-Hotjar</a
            >
          </p>
          <p class="text-justify color-black">
            หากผู้ใช้บริการไม่ต้องการให้ Hotjar
            สามารถเข้าถึงข้อมูลการใช้งานของผู้ใช้บริการได้
            สามารถเลือกที่จะปิดการบันทึกการใช้งานผ่านการตั้งค่า Cookies
          </p>
          <p class="text-justify color-black">
            <span class="title-list"
              >ความเป็นส่วนตัวของผู้ใช้ที่ยังไม่บรรลุนิติภาวะ</span
            >
            เราตระหนักถึงความจำเป็นที่จะต้องให้การคุ้มครองความเป็นส่วนตัวเพิ่มเติมเกี่ยวกับข้อมูลส่วนบุคคลที่เราอาจเก็บรวบรวมจากผู้ใช้บริการบนเว็บไซต์และแอปพลิเคชันของเรา
            คุณลักษณะบางอย่างบนเว็บไซต์และแอปพลิเคชันของเราจะมีการควบคุมอายุเพื่อไม่ให้มีไว้สำหรับการใช้โดยผู้ใช้บริการที่ยังไม่บรรลุนิติภาวะ
            เมื่อเราตั้งใจที่จะเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการ
            เราจะดำเนินขั้นตอนต่างๆ
            เพิ่มเติมเพื่อคุ้มครองความเป็นส่วนตัวของผู้ใช้บริการ ซึ่งรวมถึง
          </p>
          <ul class="set-sublist">
            <li>
              การแจ้งให้ผู้ปกครองทราบเกี่ยวกับแนวทางปฏิบัติเรื่องข้อมูลของในส่วนที่เกี่ยวข้องกับผู้ใช้บริการ
              รวมถึงประเภทของข้อมูลส่วนบุคคลที่เราอาจเก็บรวบรวมจากผู้ใช้บริการ
              การที่อาจใช้ข้อมูลเพื่อมอบประสบการณ์และบริการที่เหมาะสม
              และแบ่งปันข้อมูลกับบริษัทในเครือ
            </li>
            <li>
              การขอความยินยอมจากบิดามารดาสำหรับการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการ
              หรือการส่งข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการของเราให้กับเด็กโดยตรง
              ทั้งนี้ โดยเป็นไปตามกฎหมายที่ใช้บังคับและแนวทางปฏิบัติของ ทีมงาน
            </li>
            <li>
              การจำกัดเรื่องที่เก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการไม่ให้มากไปกว่าความจำเป็นตามสมควรสำหรับการพัฒนาและมอบประสบการณ์ด้านการเรียน
            </li>
            <li>
              การให้บิดามารดาเข้าถึงหรือมีความสามารถที่จะร้องขอการเข้าถึงข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวมจากผู้ใช้บริการและความสามารถที่จะร้องขอให้มีการเปลี่ยนแปลงหรือลบข้อมูลส่วนบุคคล
            </li>
          </ul>
          <p class="text-justify color-black">
            <span class="title-list"
              >การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว (Modification to this Privacy
              Policy)</span
            >
            ทีมงาน อาจจะเปลี่ยนแปลงนโยบายความเป็นส่วนตัวฉบับนี้เป็นครั้งคราว
            ผู้ใช้บริการ สามารถเข้าถึงนโยบายฉบับล่าสุดได้ที่เว็บไซต์ของทีมงาน
          </p>
          <p class="text-justify color-black">
            <span class="title-list">การเข้าถึงข้อมูลส่วนบุคคล</span>

            ผู้ใช้บริการมีสิทธิ์แจ้งขอไม่ให้เราประมวลผลข้อมูลส่วนบุคคลของผู้ใช้บริการเพื่อวัตถุประสงค์ด้านการตลาด
            <br />
            ผู้ใช้บริการสามารถใช้สิทธิ์ในเรื่องนี้ได้โดยเลือกช่องบนแบบฟอร์มที่เราใช้เก็บรวบรวมข้อมูลของคุณหรือติดต่อเราได้ตลอดเวลา
            <br />
            ผู้ใช้อาจเลือกไม่รับอีเมลด้านการตลาดโดยคลิกที่ลิงก์ยกเลิกการเป็นสมาชิกที่ด้านล่างของอีเมลนั้น
          </p>
          <p class="text-justify color-black">
            <span class="title-list">การลบข้อมูลออกจากบัญชี AvocadoX</span>
            คุณสามารถลบบัญชี AvocadoX ได้หากต้องการยกเลิกใช้บริการอื่นของ
            AvocadoX
            <br />
            สามารถทำตามต่อไปนี้ได้เพื่อลบข้อมูลของคุณ
            <br />
            <span class="pd-l-4 ">1. ไปที่เมนู “ข้อมูลส่วนตัว”</span><br />
            <span class="pd-l-4 ">2. คลิกที่ปุ่ม “ลบบัญชี”</span><br />
            <span class="pd-l-4 "
              >3. คลิกที่ปุ่ม “ลบ” เพื่อทำการยืนยันลบบัญชี</span
            ><br />
            <a class="color-primary" href="/profile" target="_blank"
              >ลบข้อมูลของคุณ</a
            >
          </p>

          <br />
          <span class="title-list">ข้อมูลการติดต่อ: dr.phusit@gmail.com</span>
        </div>
      </el-dialog>
    </div>
  </DefaultTemplate>
</template>
<style scop="scoped">
.title-list {
  text-align: left;
  margin: 0;
  margin-bottom: 10px;
  font-weight: bold;
  display: block;
}
.scroll-inside {
  max-height: 50vh;
  overflow: scroll;
}
.scroll-inside::-webkit-scrollbar {
  display: none;
}
.set-sublist {
  padding-left: 30px;
  text-align: left;
}
</style>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.formSignup.password) {
        callback(new Error("รหัสผ่านไม่ตรงกัน"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formSignup: {
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
          {
            min: 8,
            message: "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "กรุณากรอกยืนยันรหัสผ่าน",
            trigger: "blur",
          },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      dialogTerm: false,
      dialogPrivacy: false,
      accept: false,
      hidePass: true,
      hideConfirmPass: true,
      courseStatus: 0,
      courseId: "",
    };
  },
  mounted() {
    this.fetchCourse();
  },
  methods: {
    fetchCourse() {
      HTTP.get(`list/course/0/0/all`).then((res) => {
        if (res.data.success) {
          this.courseId = res.data.obj[0]._id;
        }
      });
    },
    nextToStep() {
      this.$refs["formSignup"].validate((valid) => {
        if (valid) {
          if (this.accept) {
            this.loading = true;
            let obj = {
              email: this.formSignup.email,
            };
            HTTP.post(`email`, obj)
              .then((res) => {
                if (res.data.success) {
                  this.$store.commit("SET_REGISTER", this.formSignup);
                  this.$router.push("/signup/step");
                } else {
                  this.$message.error("อีเมลของคุณถูกใช้งานแล้ว");
                }
              })
              .catch((e) => {
                this.alertCatchError(e);
                console.log("signup error", e);
              })
              .finally(() => {
                setTimeout(() => {
                  this.loading = false;
                }, 500);
              });
          } else {
            this.$message.error(
              "กรุณากดยอมรับเงื่อนไขการใช้บริการ และ นโยบายความเป็นส่วนตัว"
            );
          }
        }
      });
    },
    signIn(email, password) {
      this.loading = true;

      let obj = {
        email: email,
        password: password,
      };

      HTTP.post(`sign/in`, obj)
        .then((res) => {
          this.msgErrorValid = "";
          if (res.data.success) {
            this.$store.commit("SET_TOKEN", res.data.obj.token);
            let user = {
              email: res.data.obj.email,
              profileImg: res.data.obj.profileImg,
              role: res.data.obj.role,
              userId: res.data.obj.userId,
              titleName: res.data.obj.titleName,
              nameTH: res.data.obj.nameTH,
              surnameTH: res.data.obj.surnameTH,
              from: res.data.obj.from,
            };

            this.$store.commit("SET_USER", user);

            if (res.data.obj.role == 0) {
              this.fetchStudentsById(res.data.obj.userId);
            } else {
              setTimeout(() => {
                this.$router.push("/manage/course/list");
              }, 500);
            }
          } else {
            this.$message.error("อีเมลของคุณถูกใช้งานแล้ว");
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("signIn error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById(userId) {
      let obj = {
        _id: userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            if (res.data.obj.nameEN && res.data.obj.institution.name) {
              this.$store.commit("SET_HAVE_USER_DATA", true);
              this.$router.push("/my/course?tab=1");
            } else {
              this.$store.commit("SET_HAVE_USER_DATA", false);
              this.$router.push("/profile");
            }
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentsById error", e);
        });
    },
    fetchCourseStatus() {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj).then((res) => {
        if (res.data.success) {
          let pending = res.data.obj.pending.filter(
            (filter) => filter.courseId == this.courseId
          );

          let approved = res.data.obj.approved.filter(
            (filter) => filter.courseId == this.courseId
          );

          let disapproval = res.data.obj.disapproval.filter(
            (filter) => filter.courseId == this.courseId
          );

          if (pending.length > 0) {
            this.courseStatus = 2;
          }

          if (approved.length > 0) {
            this.courseStatus = 1;
          }

          if (disapproval.length > 0) {
            this.courseStatus = 3;
          }
        }
      });
    },
  },
};
</script>

<style scoped></style>
